/**
 * Empty search inquiry: Klaviyo lead capture with empty-search context on the profile.
 */
(function () {
  'use strict';

  var REVISION = '2026-04-15';

  function getLandingContext() {
    var es = window.EmptySearchLanding || {};
    return {
      scenario: es.scenario || '',
      term: es.term || '',
      resolvedScenarioKey: es.resolvedScenarioKey || '',
    };
  }

  function buildPayload(email, listId, customSource, properties) {
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: customSource,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: properties,
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId,
            },
          },
        },
      },
    };
  }

  function setMessage(el, text, isError) {
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
    el.classList.toggle('empty-search-notify__message--error', !!isError);
  }

  function initForm() {
    var form = document.getElementById('empty-search-notify-form');
    var cfg = document.getElementById('empty-search-klaviyo-config');
    if (!form || !cfg) return;

    var successEl = document.querySelector('[data-empty-search-notify-success]');
    var headingEl = document.querySelector('[data-empty-search-notify-heading]');
    var companyId = (cfg.getAttribute('data-company-id') || '').trim();
    var listId = (cfg.getAttribute('data-list-id') || '').trim();
    var customSource = (cfg.getAttribute('data-custom-source') || 'Empty search landing').trim();
    var msgEl = form.querySelector('[data-empty-search-notify-message]');
    var submitBtn = form.querySelector('[type="submit"]');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!companyId) {
        setMessage(msgEl, 'Klaviyo Company ID is not configured in the theme editor.', true);
        return;
      }
      if (!listId) {
        setMessage(msgEl, 'Klaviyo list ID is missing.', true);
        return;
      }

      var emailInput = form.querySelector('[name="email"]');
      var consent = form.querySelector('[name="consent"]');
      var email = emailInput ? String(emailInput.value || '').trim() : '';
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        setMessage(msgEl, 'Please enter a valid email address.', true);
        return;
      }
      if (consent && !consent.checked) {
        setMessage(msgEl, 'Please confirm you want to receive emails from us.', true);
        return;
      }

      var ctx = getLandingContext();

      var properties = {
        empty_search_scenario_param: ctx.scenario,
        empty_search_term_param: ctx.term,
        empty_search_scenario_key: ctx.resolvedScenarioKey,
      };

      setMessage(msgEl, '', false);
      if (submitBtn) submitBtn.disabled = true;

      var url =
        'https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(companyId);

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: REVISION,
        },
        body: JSON.stringify(buildPayload(email, listId, customSource, properties)),
      })
        .then(function (res) {
          if (res.status === 202) {
            form.reset();
            form.hidden = true;
            if (headingEl) headingEl.hidden = true;
            if (successEl) successEl.hidden = false;
            return;
          }
          return res.text().then(function (text) {
            var detail = '';
            try {
              var body = text ? JSON.parse(text) : null;
              if (body && body.errors && body.errors[0] && body.errors[0].detail) {
                detail = String(body.errors[0].detail);
              }
            } catch (parseErr) {
              detail = text ? String(text).slice(0, 200) : '';
            }
            setMessage(
              msgEl,
              detail || 'Something went wrong. Please try again in a moment.',
              true
            );
          });
        })
        .catch(function () {
          setMessage(msgEl, 'Network error. Please try again.', true);
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  function run() {
    initForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
